import React, { useState } from "react";
import './spinWheel.css';
import spinWheel from '../../images/spinWheel.png';
import arrow from '../../images/spinArrow.png';
import wheelBg from '../../images/spinWheelBorder.png';
import wheelLogo from '../../images/spinWheelLogo.png';
import SpinWheel2 from '../SpinWheel2/spinWheel2';

const SpinWheel = ({ reference }) => {
    const [display, setDisplay] = useState(false)
    const displaySpinButton = () => setDisplay(true)

    return (
        <div>
                
            {display ? <SpinWheel2 /> :
                <div className='spinWheel-container' ref={reference}>
           
                    <div className="container">
                        <div className='col-md-12 d-flex  flex-wrap  justify-content-center align-items-center subSecton'>
                            <div className='col-12 col-md-6  spinWheel-title-container'>
                                <div className='spinWheel-title'>
                                    <h1 className='spinWheel-title'>Spin for your <br />First Satback</h1>
                                </div>
                                <div className='spinWheel-subtitle'>
                                    <p>Earn Bitcoins with every transaction you make </p>
                                </div>
                                <div className='spinWheel-button'>
                                    <button className='button' onClick={displaySpinButton}>Spin for Free Bitcoin</button>
                                </div>
                            </div>
                            <div className='col-6 col-md-6 text-center d-flex justify-content-center wheel-container'>
                                <img className='wheelBg' src={wheelBg} alt='wheel' />
                                <img className='wheel' src={spinWheel} alt='Reward wheel' />
                                <img className='wheelLogo' src={wheelLogo} alt='logo' />
                                <img className='marker' src={arrow} alt='Arrow' />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
export default SpinWheel;